export default "./dist/stdassets/images/icons/icon_menuarrow_disabled.png";